import { handleRequest, generateSearchQuery } from 'actions/util/requestUtils';
import axios from 'axios';
import { ACTION_CONSTANTS } from 'actions/constants';
import { store } from 'index';

export class BaseActions {
  constructor({ endpoint, constantGroup, apiVersion = 'v1' }) {
    this.fullPath = `${process.env.API_ROUTE}${apiVersion}/${endpoint}`;
    this.constantGroup = constantGroup;
  }

  search = ({
    data = {}, // POST data
    query = {}, // query string data
    overwrite = true, // overwrite bucket instead of update
    background = false, // no loader
    noError = false, // no error modal
    bucket, // which bucket (defaults to main bucket null)
    customLoader // which loader listener (optional)
  }) => {
    const request = axios.post(
      `${this.fullPath}/search${generateSearchQuery(query)}`,
      data
    );

    const actionType = ACTION_CONSTANTS[this.constantGroup].mapPayload;

    return dispatch => {
      return handleRequest({
        dispatch,
        bucket,
        request,
        actionType,
        noError,
        overwrite,
        hideLoader: background,
        customLoader: background ? null : customLoader
      });
    };
  };

  save = ({
    data, // POST data
    query = {}, // query string data
    background = false, // create or update model in store prior to server response (hides loader as well)
    backgroundExtras = {}, // if want to create or update model in store with data other than that in request
    noError = false, // no error modal,
    shallow = false, // no request, simply updating store
    bucket // which bucket (defaults to main bucket null)
  }) => {
    const isArray = Array.isArray(data);
    let dataFormatted = {};

    if (isArray) {
      dataFormatted.collection = data;
    } else {
      dataFormatted = data;
    }

    let request;
    if (!shallow) {
      request = axios.post(
        `${this.fullPath}/save${generateSearchQuery(query)}`,
        dataFormatted
      );
    }

    const shallowData = {
      collection: isArray
        ? dataFormatted.collection.map(m =>
            Object.assign({}, m, backgroundExtras)
          )
        : [Object.assign({}, dataFormatted, backgroundExtras)]
    };

    return dispatch => {
      let shallowDispatch;
      let prevData;
      if (shallow || background) {
        prevData = JSON.parse(
          JSON.stringify(store.getState()[this.constantGroup])
        );

        shallowDispatch = dispatch({
          type: ACTION_CONSTANTS[this.constantGroup].mapPayload,
          payload: shallowData,
          bucket
        });
      }

      if (shallow) {
        return shallowDispatch;
      } else {
        return handleRequest({
          request,
          noError,
          onError: () => {
            if (prevData) {
              store.dispatch({
                type: ACTION_CONSTANTS[this.constantGroup].mapPayload,
                payload: { collection: prevData.list, bucket }
              });
            }
          },
          actionType: ACTION_CONSTANTS[this.constantGroup].mapPayload,
          hideLoader: background
        });
      }
    };
  };

  delete = ({
    id, // id to delete
    ids = [], // ids to delete
    query = {}, // query string data
    background = false, //delete model in store prior to server response (hides loader as well)
    shallow = false, // no request, simply deleting in store
    bucket // which bucket (defaults to main bucket null)
  }) => {
    if (id) ids = [id];

    let request;
    if (!shallow) {
      request = axios.post(
        `${this.fullPath}/delete${generateSearchQuery(query)}`,
        { ids }
      );
    }

    return dispatch => {
      let shallowDispatch;
      if (shallow || background) {
        shallowDispatch = dispatch({
          type: ACTION_CONSTANTS[this.constantGroup].deletePayload,
          payload: {
            collection: ids.map(id => {
              return { id };
            })
          }
        });
      }

      if (shallow) {
        return shallowDispatch;
      } else {
        return handleRequest({
          bucket,
          request,
          actionType: ACTION_CONSTANTS[this.constantGroup].deletePayload,
          hideLoader: background
        });
      }
    };
  };

  clear = ({ bucket }) => {
    return dispatch => {
      return dispatch({
        type: ACTION_CONSTANTS[this.constantGroup].clear,
        bucket
      });
    };
  };
}



// WEBPACK FOOTER //
// ./src/actions/util/baseActions.js